export default {
  deals: 'Сделки',
  numberDeal: 'Номер сделки',
};
